<template>
    <div class="roadmap-step">
        <div class="roadmap-step-order" @click="showSteps" :class="`bg-inverse-${contentClass}`" v-b-tooltip.top="statusText">
            <div class="roadmap-step-status" :class="`bg-${contentClass}`" >
                <i :class="iconClass"></i>
            </div>
            {{ stepIn.order }}
        </div>
        <div class="roadmap-step-title">
            <p class="deadline-date" v-if="stepIn.deadlinedate">
                {{stepIn.deadline.date | date_written}}
            </p>
        </div>
    </div>
</template>
<script>

export default {
    name: "design-2021-roadmap-step-component",
    props: ['stepIn', 'total', 'current'],
    data() {
        return {
            width: 100 / this.total,
            iconClass: '',
            statusText: '',
            contentClass: '',
        }
    },
    methods: {
        showSteps: function (evt) {
            this.$emit('showSteps', evt);
        },
        setData() {
            if (this.stepIn.status.length > 0) {
                if (this.stepIn.status[0].finished) {
                    if (this.stepIn.status[0].status === 0) {
                        this.iconClass = 'far fa-fw fa-ellipsis-h';
                        this.statusText = this.stepIn.title ? this.stepIn.title : 'Stap ' + this.stepIn.order;//'Afgerond / ingeleverd';
                        this.contentClass = 'warning';
                    } else if (this.stepIn.status[0].status === 1) {
                        this.iconClass = 'far fa-fw fa-check';
                        this.statusText = this.stepIn.title ? this.stepIn.title : 'Stap ' + this.stepIn.order;//'Goedgekeurd';
                        this.contentClass = 'success';
                    }
                } else if (this.stepIn.status[0].status === 2)  {
                    this.iconClass = 'fal fa-fw fa-times';
                    this.statusText = this.stepIn.title ? this.stepIn.title : 'Stap ' + this.stepIn.order;//'Opnieuw';
                    this.contentClass = 'danger';
                } else {
                    this.iconClass = 'fas fa-fw fa-pencil';
                    this.statusText = 'Open';
                    this.contentClass = 'primary';
                }
            } else {
                this.iconClass = 'fas fa-fw fa-pencil';
                this.statusText = this.stepIn.title ? this.stepIn.title : 'Stap ' + this.stepIn.order;//'Open';
                this.contentClass = 'primary';
            }
        }
    },
    watch: {
        stepIn: function () {
            this.setData();
        }
    },
    mounted() {
        this.setData();
    }
}

</script>

<style scoped lang="scss">
.roadmap-step {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-width: max-content;
    position: relative;
    justify-content: center;
    align-items: center;
}

.roadmap-step-order {
    height: 60px;
    width: 69px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: $border-radius-content;
    background-color: $secondary-background-color;
    z-index: 20;
    box-shadow: 0 0 10px 0 rgba($black, 0.1);

    &:hover {
        cursor: pointer;
    }
}

.roadmap-step-title {
    display: inline-flex;
    width: 69px;
    margin-top: map-get($grid-gutter-spacing, 'fifteen');
    font-size: 0.6875rem;
    font-weight: $font-weight-bold;
    color: $text-muted-color;
    min-height: 26.5px;
}

.roadmap-step-status {
    position: absolute;
    top: -10px;
    right: -11px;
    color: $white;
    line-height: 1;
    padding: 4px;
    border-radius: 4px;

    i {
        font-size: 0.875rem;
    }
}

.deadline-date {
    width: 100%;
    text-align: center;
}

</style>
